import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from './style/GlobalStyles';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './Pages/Home';
import AboutPage from './Pages/AboutPage';
import FeaturesPage from './Pages/FeaturesPage';
import TeamPage from './Pages/TeamPage';
import Pricing from './Pages/PricingPage';
import ContactUs from './Pages/ContactUsPage';
import AiTracking from './Pages/AiTrackingPage';
import PrivacyPolicy from './Pages/PrivatPolicy';
import CookiePolicy from './Pages/CookiePolicy';
import TermsOfService from './Pages/TermsOfService';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';



const theme = {
  colors: {
    background: '#000000',
    surface: '#0a0a0a',
    primary: '#1d4ed8',
    text: '#ffffff',
    accent: '#3b82f6',
  },
  fonts: {
    // heading: '-apple-system, BlinkMacSystemFont, "Segoe UI", Inter, sans-serif',
    // body: 'Inter, -apple-system, sans-serif',
    heading: '-apple-system',
    body: '-apple-system',
  },
};

function App() {
  return (
    <ThemeProvider theme={theme}>
    <I18nextProvider i18n={i18n}>
      <GlobalStyles />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/ai" element={<AiTracking />} />
          <Route path="/privatpolicy" element={<PrivacyPolicy />} />
          <Route path="/cookiepolicy" element={<CookiePolicy />} />
          <Route path="/termofservice" element={<TermsOfService />} />
        </Routes>
      </main>
      <Footer />
    </I18nextProvider>
    </ThemeProvider>
  );
}

export default App;